import React, { useReducer, useState, useEffect } from "react";
import styled from "styled-components";
import useSWR from "swr";
import CarouselHeader from "../components/carousel/CarouselHeader";
import NoReviewsState from "../components/carousel/NoReviewsState";
import ReviewCarousel from "../components/carousel/ReviewCarousel";
import ReviewModal from "../components/carousel/ReviewModal";
import RecentReviewsJsonLDWrapper from "../components/RecentReviewsJsonLDWrapper";
import { AppContext, defaultAppState, reducer } from "../containers/All";

const CarouselRoot = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 16px 16px;
`;

const fetcher = (...args) => fetch(...args).then((r) => r.json());

const RecentCarousel = (props) => {
  const [state, dispatch] = useReducer(reducer, { ...defaultAppState, page: 1 });
  const [modalReview, setModalReview] = useState(null);

  const {
    merchant: merchantId,
    num = 9,
    truncateDest = "/reviews",
    currentLocationReviewsOnly = false,
    randomize = false,
    thirdParty = false,
    lines = "4",
  } = props;

  const merchantUrl = `${process.env.REACT_APP_API_HOST}/api/public/v2/merchants/${merchantId}.json?widget=carousel`;
  const { data: merchantData } = useSWR(merchantUrl, fetcher, {
    revalidateOnFocus: false,
  });

  const merchant = merchantData && merchantData.merchant;

  const reviewsUrl = merchant
    ? `${process.env.REACT_APP_API_HOST}/api/public/v2/merchants/${merchant.id}/reviews.json?limit=${num}&page=1&filter=null&thirdParty=${thirdParty}&randomize=${randomize}&skipPagination=true&currentLocationReviewsOnly=${currentLocationReviewsOnly}`
    : null;

  const { data: reviewsData } = useSWR(reviewsUrl, fetcher, {
    revalidateOnFocus: false,
  });

  useEffect(() => {
    if (reviewsData && reviewsData.reviews) {
      dispatch({ type: "LOADED_REVIEWS", payload: reviewsData.reviews });
    }
  }, [reviewsData]);

  if (!merchant) {
    return null;
  }

  const reviews = state.reviews;

  if (!reviews || reviews.length === undefined) {
    return null;
  }

  const isCancelled = merchant.state === "cancelled";

  return (
    <AppContext.Provider value={{ state, dispatch, settings: { ...props } }}>
      <CarouselRoot className="fdn-carousel">
        <RecentReviewsJsonLDWrapper merchant={merchant} reviews={reviews} />
        {reviews.length === 0 ? (
          <NoReviewsState
            merchant={merchant}
            isCancelled={isCancelled}
          />
        ) : (
          <React.Fragment>
            <CarouselHeader
              merchant={merchant}
              truncateDest={truncateDest}
              isCancelled={isCancelled}
            />
            <ReviewCarousel
              reviews={reviews}
              truncateDest={truncateDest}
              onReadMore={setModalReview}
              lines={lines}
            />
            {modalReview && (
              <ReviewModal
                review={modalReview}
                onClose={() => setModalReview(null)}
              />
            )}
          </React.Fragment>
        )}
      </CarouselRoot>
    </AppContext.Provider>
  );
};

export default RecentCarousel;



// WEBPACK FOOTER //
// ./src/containers/RecentCarousel.jsx